// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { RelationIn } from './relationIn.zod.ts';

export const relationsInRelationsMax = 50;

export const RelationsIn = zod.object({
  "relations": zod.array(RelationIn).max(relationsInRelationsMax),
  "revision": zod.int().min(1)
});

export type RelationsIn = zod.input<typeof RelationsIn>;
export type RelationsInOutput = zod.output<typeof RelationsIn>;
